// extracted by mini-css-extract-plugin
module.exports =  {"container":"_13c3691929--container--o3slX","icon":"_13c3691929--icon--oKrBZ","name":"_13c3691929--name--litUi"};